import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

const styles = () => ({
  root: {
    fontSize: '13px',
    fontWeight: 'bold',
    padding: '8px 0px',
    borderBottom: '1px solid #E7E9EB',
    marginBottom: '16px',
  }
});

const SectionHead = (props) => (
  <div className={props.classes.root} style={props.style}>{props.text}</div>
)

SectionHead.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default withStyles(styles)(SectionHead);



// WEBPACK FOOTER //
// ./src/components/Timeline/dialogs/parts/SectionHead.jsx